export const DR_APP_NAME = "达人连连"